import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(bc|ad)/i,
  wide: /^(ngaphambi kokrestu|anno domini)/i,
};
const parseEraPatterns = {
  any: [/^(b|n)/i, /^a/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^kota-[1234]/i,
  wide: /^ikota (yokuqala|yesibini|yesithathu|yesine)/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/kota-1/i, /kota-2/i, /kota-3/i, /kota-4/i],
  wide: [
    /^ikota yokuqala/i,
    /ikota yesibini/i,
    /ikota yesithathu/i,
    /ikota yesine/i,
  ],
};

const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mat|apr|meyi|jun|jul|aga|sep|okt|nov|dis)/i,
  wide: /^(janyuwari|februwari|matshi|apreli|meyi|juni|julayi|agasti|septemba|oktobha|novemba|disemba)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[cmbtsh]/i,
  short: /^(caw|mvu|bin|tha|sin|hla|mgq)/i,
  abbreviated: /^(caw|mvu|bin|tha|sin|hla|mgq)/i,
  wide: /^(cawa|mvulo|lwesibini|lwesithathu|lwesine|lwesihlanu|mgqibelo)/i,
};
const parseDayPatterns = {
  narrow: [/^c/i, /^m/i, /^b/i, /^t/i, /^s/i, /^h/i, /^m/i],
  short: [/^caw/i, /^mvu/i, /^bin/i, /^tha/i, /^sin/i, /^hla/i, /^mgq/i],
  abbreviated: [/^caw/i, /^mvu/i, /^bin/i, /^tha/i, /^sin/i, /^hla/i, /^mgq/i],
  any: [
    /^cawa/i,
    /^mvulo/i,
    /^lwesibini/i,
    /^lwesithathu/i,
    /^lwesine/i,
    /^lwesihlanu/i,
    /^mgqibelo/i,
  ],
};

const matchDayPeriodPatterns = {
  narrow:
    /^(k|e|ezinzulwini zobusuku|emini|kusasa|emva kwemini|ngorhatya|ubusuku)/i,
  abbreviated:
    /^(AM|PM|ezinzulwini zobusuku|emini|kusasa|emva kwemini|ngorhatya|ubusuku)/i,
  wide: /^(a.m.|p.m.|ezinzulwini zobusuku|emini|kusasa|emva kwemini|ngorhatya|ubusuku)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /^k/i,
    pm: /^e/i,
    midnight: /^ezinzulwini zobusuku/i,
    noon: /^emini/i,
    morning: /kusasa/i,
    afternoon: /emva kwemini/i,
    evening: /ngorhatya/i,
    night: /ubusuku/i,
  },
  abbreviated: {
    am: /^AM/i,
    pm: /^PM/i,
    midnight: /^ezinzulwini zobusuku/i,
    noon: /^emini/i,
    morning: /kusasa/i,
    afternoon: /emva kwemini/i,
    evening: /ngorhatya/i,
    night: /ubusuku/i,
  },
  any: {
    am: /a.m./i,
    pm: /p.m./i,
    midnight: /^ezinzulwini zobusuku/i,
    noon: /^emini/i,
    morning: /kusasa/i,
    afternoon: /emva kwemini/i,
    evening: /ngorhatya/i,
    night: /ubusuku/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any',
  }),
};

export default match;
